var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.42857C1 3.51926 1.29803 2.64719 1.82852 2.00421C2.35901 1.36122 3.0785 1 3.82873 1H10.1713C10.9215 1 11.641 1.36122 12.1715 2.00421C12.702 2.64719 13 3.51926 13 4.42857V9.57143C13 10.4807 12.702 11.3528 12.1715 11.9958C11.641 12.6388 10.9215 13 10.1713 13H3.82873C3.0785 13 2.35901 12.6388 1.82852 11.9958C1.29803 11.3528 1 10.4807 1 9.57143V4.42857Z",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.42857C1 3.51926 1.29803 2.64719 1.82852 2.00421C2.35901 1.36122 3.0785 1 3.82873 1H10.1713C10.9215 1 11.641 1.36122 12.1715 2.00421C12.702 2.64719 13 3.51926 13 4.42857V9.57143C13 10.4807 12.702 11.3528 12.1715 11.9958C11.641 12.6388 10.9215 13 10.1713 13H3.82873C3.0785 13 2.35901 12.6388 1.82852 11.9958C1.29803 11.3528 1 10.4807 1 9.57143V4.42857Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.42857C1 3.51926 1.29803 2.64719 1.82852 2.00421C2.35901 1.36122 3.0785 1 3.82873 1H10.1713C10.9215 1 11.641 1.36122 12.1715 2.00421C12.702 2.64719 13 3.51926 13 4.42857V9.57143C13 10.4807 12.702 11.3528 12.1715 11.9958C11.641 12.6388 10.9215 13 10.1713 13H3.82873C3.0785 13 2.35901 12.6388 1.82852 11.9958C1.29803 11.3528 1 10.4807 1 9.57143V4.42857Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.75L9.31818 6.93182L5.5 9.11364V4.75Z",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.75L9.31818 6.93182L5.5 9.11364V4.75Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.75L9.31818 6.93182L5.5 9.11364V4.75Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.8b4c61b67d45993a0994fbcd010ee472.svg";
export { ForwardRef as ReactComponent };